import React from 'react'
import {css, keyframes} from '@emotion/react'

// Exact paths from Figma's sparkles-2 icon (16x16 viewBox, node 8867:527084).

// Big star (left), geometric center (5, 8)
const BIG_STAR_D =
  'M5.75 3.75C5.75 3.33579 5.41421 3 5 3C4.58579 3 4.25 3.33579 4.25 3.75C4.25 4.5961 3.83781 5.47652 3.15717 6.15717C2.47652 6.83781 1.5961 7.25 0.75 7.25C0.335786 7.25 0 7.58579 0 8C0 8.41421 0.335786 8.75 0.75 8.75C1.5961 8.75 2.47652 9.16219 3.15717 9.84283C3.83781 10.5235 4.25 11.4039 4.25 12.25C4.25 12.6642 4.58579 13 5 13C5.41421 13 5.75 12.6642 5.75 12.25C5.75 11.4039 6.16219 10.5235 6.84283 9.84283C7.52348 9.16219 8.4039 8.75 9.25 8.75C9.66421 8.75 10 8.41421 10 8C10 7.58579 9.66421 7.25 9.25 7.25C8.4039 7.25 7.52348 6.83781 6.84283 6.15717C6.16219 5.47652 5.75 4.5961 5.75 3.75ZM4.21783 7.21783C4.51157 6.92408 4.77639 6.59413 5 6.23713C5.22361 6.59413 5.48843 6.92408 5.78217 7.21783C6.07592 7.51157 6.40587 7.77639 6.76287 8C6.40587 8.22361 6.07592 8.48843 5.78217 8.78217C5.48843 9.07592 5.22361 9.40587 5 9.76287C4.77639 9.40587 4.51157 9.07592 4.21783 8.78217C3.92408 8.48843 3.59413 8.22361 3.23713 8C3.59413 7.77639 3.92408 7.51157 4.21783 7.21783Z'

// Small star top-right, geometric center (13, 3)
const SMALL_STAR_A_D =
  'M12.9999 0C13.4142 0 13.7499 0.335786 13.7499 0.75C13.7499 1.0863 13.917 1.46672 14.2251 1.77481C14.5332 2.08291 14.9136 2.25 15.2499 2.25C15.6642 2.25 15.9999 2.58579 15.9999 3C15.9999 3.41421 15.6642 3.75 15.2499 3.75C14.9136 3.75 14.5332 3.91709 14.2251 4.22519C13.917 4.53328 13.7499 4.9137 13.7499 5.25C13.7499 5.66421 13.4142 6 12.9999 6C12.5857 6 12.2499 5.66421 12.2499 5.25C12.2499 4.9137 12.0829 4.53328 11.7748 4.22519C11.4667 3.91709 11.0862 3.75 10.7499 3.75C10.3357 3.75 9.99994 3.41421 9.99994 3C9.99994 2.58579 10.3357 2.25 10.7499 2.25C11.0862 2.25 11.4667 2.08291 11.7748 1.77481C12.0829 1.46672 12.2499 1.0863 12.2499 0.75C12.2499 0.335786 12.5857 0 12.9999 0ZM12.9999 2.65852C12.947 2.71983 12.892 2.77888 12.8354 2.83547C12.7788 2.89207 12.7198 2.94701 12.6585 3C12.7198 3.05299 12.7788 3.10793 12.8354 3.16453C12.892 3.22112 12.947 3.28017 12.9999 3.34148C13.0529 3.28017 13.1079 3.22112 13.1645 3.16453C13.2211 3.10793 13.2801 3.05299 13.3414 3C13.2801 2.94701 13.2211 2.89207 13.1645 2.83547C13.1079 2.77888 13.0529 2.71983 12.9999 2.65852Z'

// Small star bottom-right, geometric center (13, 13)
const SMALL_STAR_B_D =
  'M12.9999 10.0001C13.4142 10.0001 13.7499 10.3359 13.7499 10.7501C13.7499 11.0864 13.917 11.4668 14.2251 11.7749C14.5332 12.083 14.9136 12.2501 15.2499 12.2501C15.6642 12.2501 15.9999 12.5859 15.9999 13.0001C15.9999 13.4143 15.6642 13.7501 15.2499 13.7501C14.9136 13.7501 14.5332 13.9172 14.2251 14.2253C13.917 14.5334 13.7499 14.9138 13.7499 15.2501C13.7499 15.6643 13.4142 16.0001 12.9999 16.0001C12.5857 16.0001 12.2499 15.6643 12.2499 15.2501C12.2499 14.9138 12.0829 14.5334 11.7748 14.2253C11.4667 13.9172 11.0862 13.7501 10.7499 13.7501C10.3357 13.7501 9.99994 13.4143 9.99994 13.0001C9.99994 12.5859 10.3357 12.2501 10.7499 12.2501C11.0862 12.2501 11.4667 12.083 11.7748 11.7749C12.0829 11.4668 12.2499 11.0864 12.2499 10.7501C12.2499 10.3359 12.5857 10.0001 12.9999 10.0001ZM12.9999 12.6586C12.947 12.72 12.892 12.779 12.8354 12.8356C12.7788 12.8922 12.7198 12.9471 12.6585 13.0001C12.7198 13.0531 12.7788 13.108 12.8354 13.1646C12.892 13.2212 12.947 13.2803 12.9999 13.3416C13.0529 13.2803 13.1079 13.2212 13.1645 13.1646C13.2211 13.108 13.2801 13.0531 13.3414 13.0001C13.2801 12.9471 13.2211 12.8922 13.1645 12.8356C13.1079 12.779 13.0529 12.72 12.9999 12.6586Z'

// Timings ported from designer's Lottie files (Jitter export @ 60fps).
// Intro: scale 0→1 + rotate -45°→0° over ~654ms per star, staggered starts.
// Loop (3860ms): two 90° rotation beats per cycle, staggered per star.
const INTRO_MS = 970
const LOOP_MS = 3860

const intro = keyframes`
  0% { transform: rotate(-45deg) scale(0); }
  100% { transform: rotate(0deg) scale(1); }
`

// Medium star (top-right). Rotate 0→90 at 0–400ms, hold, rotate 90→180 at 1931–2331ms.
const smallStarALoop = keyframes`
  0% { transform: rotate(0deg); }
  10.36% { transform: rotate(90deg); }
  50.03% { transform: rotate(90deg); }
  60.39% { transform: rotate(180deg); }
  100% { transform: rotate(180deg); }
`

// Small star (bottom-right). Rotate at 316–717ms, then 2247–2648ms.
const smallStarBLoop = keyframes`
  0% { transform: rotate(0deg); }
  8.19% { transform: rotate(0deg); }
  18.57% { transform: rotate(90deg); }
  58.22% { transform: rotate(90deg); }
  68.60% { transform: rotate(180deg); }
  100% { transform: rotate(180deg); }
`

// Big star (left). Rotate at 731–1131ms, then 2662–3062ms.
const bigStarLoop = keyframes`
  0% { transform: rotate(0deg); }
  18.94% { transform: rotate(0deg); }
  29.30% { transform: rotate(90deg); }
  68.96% { transform: rotate(90deg); }
  79.33% { transform: rotate(180deg); }
  100% { transform: rotate(180deg); }
`

const baseStyle = css`
  transform-box: fill-box;
  transform-origin: center;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1);

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

// Intro delays match the Lottie per-star start frames.
const bigStarStyle = css`
  ${baseStyle};
  animation:
    ${intro} ${INTRO_MS - 316}ms cubic-bezier(0.22, 1, 0.36, 1) 316ms both,
    ${bigStarLoop} ${LOOP_MS}ms linear ${INTRO_MS}ms infinite;
`

const smallStarAStyle = css`
  ${baseStyle};
  animation:
    ${intro} ${INTRO_MS - 316}ms cubic-bezier(0.22, 1, 0.36, 1) 0ms both,
    ${smallStarALoop} ${LOOP_MS}ms linear ${INTRO_MS}ms infinite;
`

const smallStarBStyle = css`
  ${baseStyle};
  animation:
    ${intro} ${INTRO_MS - 316}ms cubic-bezier(0.22, 1, 0.36, 1) 131ms both,
    ${smallStarBLoop} ${LOOP_MS}ms linear ${INTRO_MS}ms infinite;
`

export const AnimatedSparkles = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    fillRule="evenodd"
    clipRule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d={BIG_STAR_D} css={bigStarStyle} />
    <path d={SMALL_STAR_A_D} css={smallStarAStyle} />
    <path d={SMALL_STAR_B_D} css={smallStarBStyle} />
  </svg>
)
